import React, { useContext, useEffect, useRef, useState } from 'react'
import { Checkbox, Divider, Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { FaRegEnvelope } from 'react-icons/fa6'
import { Button } from 'components'
import pattern from 'assets/images/Wallpaper.jpg'
import logo from 'assets/images/warehouseLogo.png'
import Wlogo from 'assets/images/wLetter.png'
import ls from 'utils/ls'
import axios from 'axios'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from 'contexts'

// import firebase from 'firebase/app';
// import 'firebase/messaging';

const loginValues = ls.get('loginInfo')

function Login() {
  const [ loading, setLoading ] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const origin = location.state?.from?.pathname || '/'
  const { action, state } = useContext(AuthContext);
  // useEffect(() => {
  //   if (!firebase.apps.length) {
  //     firebase.initializeApp({
  //       apiKey: "AIzaSyB_vBtq7PDwsWPQ-N2mDBML4V4gaOkyEz8",
  //       authDomain: "hr-online-da2b8.firebaseapp.com",
  //       projectId: "hr-online-da2b8",
  //       storageBucket: "hr-online-da2b8.appspot.com",
  //       messagingSenderId: "743177108443",
  //       appId: "1:743177108443:web:f0bcbc031097c3d23105fe",
  //       measurementId: "G-4WF40J4CWG"
  //     });
  //   }

  //   const messaging = firebase.messaging();
  //   messaging.requestPermission()
  //     .then(() => messaging.getToken())
  //     .then((token) => {
  //       console.log('Registration token:', token);
  //     })
  //     .catch((err) => {
  //       console.error('Error getting registration token:', err);
  //     });

  //   messaging.onTokenRefresh(() => {
  //     messaging.getToken()
  //       .then((refreshedToken) => {
  //         console.log('Refreshed token:', refreshedToken);
  //       })
  //       .catch((err) => {
  //         console.error('Unable to retrieve refreshed token:', err);
  //       });
  //   });
  // }, []);

  const navigateRoute = () => {
    navigate(origin)
  }

  const handleSubmit = (values) => {
    if(values.rememberMe){
      ls.set('remember', values)
    }
    else{
      ls.remove('remember')
    }
    setLoading(true)
    axios({
      method: 'post',
      url: 'login',
      data: values
    }).then((res) => {
      // initContextData(res.data)
      action.initToken(res.data.token, res.data )
      navigateRoute()
    }).catch((err) => {
    }).finally(() => {
      setLoading(false)
    })
  }

  if(state.token){
    navigate('/')
  }

  return (
    <div className='flex w-screen h-screen'>
      <div className='flex-1 bg-center bg-cover relative p-12 flex justify-center items-center bg-gradient-to-t from-[#021D7C] to-[#0574E5]'>
      <div className='absolute inset-0' style={{ width: '100%', height: '100%', background: `url(${pattern})`, backgroundSize: 'cover' }}></div>
        {/* <div className=' bg-opacity-20 max-w-[600px] aspect-square relative rounded-2xl overflow-hidden backdrop-blur text-white flex flex-col justify-center p-[60px] text-center'>
          <div className='absolute inset-0 bg-[#7398c7] -z-10 opacity-20'></div>
          <div className='text-4xl mb-4 flex flex-col justify-center'><img  src={Wlogo} alt='letterLogo'/></div>
          <p className='text-[#C2C9D1]'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
          </p>
        </div> */}
      </div>{/* w-2/5*/}
      <div className='w-[850px] flex flex-col justify-between'>
        <div className='flex justify-between px-8 py-6'>
          <img width={150} src={logo} alt='logo'/> 
          {/* <div className='text-secondary'>Та бүртгэлтэй юу? 
          <Link to='/register' >
            <button className='text-primary hover:underline ml-2'>Бүртгүүлэх</button>
            </Link>
            </div> */}
        </div>
        <div className='flex flex-col self-center w-1/2'>
          <div className='text-center text-4xl'>Тавтай морилно уу!</div>
          <div className='text-center text-secondary mt-4'>Агуулахын систем V1.0</div>
          <Divider orientation='center'>Нэвтрэх</Divider>
          <Form 
            size='large' 
            onFinish={handleSubmit}
            initialValues={loginValues}
          >
            <Form.Item name='email' rules={[{required: true, message: 'И-Мэйл хаяг оруулна уу'}]}>
              <Input prefix={<FaRegEnvelope/>} placeholder="И-Мэйл"/>
            </Form.Item>
            <Form.Item name='password' rules={[{required: true, message: 'Та үсэг болон тэмдэгт оруулахгүй 6 оронтой тоо оруулна уу'}]}>
              <Input.Password prefix={<LockOutlined/>} placeholder="Нууц үг"/>
            </Form.Item>
            <div className='flex justify-between'>
              <Form.Item name='rememberMe' valuePropName="checked">
                <Checkbox>Намайг сана</Checkbox>
              </Form.Item>
              <Form.Item>
                <button className='text-primary hover:underline'>Нууц үгээ мартсан</button>
              </Form.Item>
            </div>
            <Form.Item>
              <Button 
                className='w-full' 
                type='primary' 
                htmlType='submit'
                loading={loading}
              >
                Нэвтрэх
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className='self-center text-secondary text-xs p-2'>© 2023 Fractaltech LLC. Зохиогчийн эрх хамгаалагдсан</div>
      </div>
    </div>
  )
}

export default Login